import * as hast from "hast-util-find-and-replace";

const placeholderRegex = /\{\{([^\s]+)}}/gi;

export const rehypePlaceholders = () => {
    const replacePlaceholder = (value,placeholder) => {
        return [
            {
                type: 'element',
                tagName: 'placeholder',
                properties: {
                    value: placeholder,
                },
            },
        ];
    };
    return (tree, _file) => {
        // @ts-ignore
        return hast.findAndReplace(tree, [[placeholderRegex, replacePlaceholder]]);
    };
};

export const Placeholder = (placeholders) => ({ value }) => {
    const Placeholder = placeholders[value];
    return Placeholder ? <Placeholder/> : null;
};